export default {"src":"/_next/static/media/klarna.0882dcfa.svg","height":23,"width":42,"blurWidth":0,"blurHeight":0};